import BarcodeGenerator from "../components/barcode-generator";
import PageLayout from "../components/common/page-layout";
import { RequireAuth } from "../hooks/use-auth";

/** Route page for the bulk barcode generator internal tool. */
const BarcodeGeneratorPage = () => {
  return (
    <RequireAuth>
      <PageLayout maxWidth={false} title="Barcode generator">
        <BarcodeGenerator />
      </PageLayout>
    </RequireAuth>
  );
};

export default BarcodeGeneratorPage;
